export const getPopoverOptions = ({ setSelectedQuote, convertQuote }) => {
  return [
    {
      label: 'Preview Details',
      icon: 'eye-mono',
      onClick: () => setSelectedQuote()
    },
    {
      label: 'Convert to invoice',
      icon: 'import-mono',
      onClick: () => convertQuote()
    }
  ];
};
